import React from "react";
import { useScopeParams } from "@/hooks/useScopeParams";
import { toBackendTrialId } from "@/utils/trialIdMap";
import VivoLogo from "../../assets/icons/Vivo_logo_light.png";

interface Trial {
  id: string;
  name: string;
  title: string;
}

interface UserInfo {
  trials?: Trial[];
}

export default function AskVivoHeader({ userInfo }: { userInfo?: UserInfo }) {
  const { id: rawId, scope } = useScopeParams();
  const id = toBackendTrialId(rawId);

  let trialName = "";
  let trialNCT = "";
  if (userInfo && userInfo.trials && userInfo.trials.length > 0) {
    for (const trial of userInfo.trials) {
      if (trial.id === id) {
        trialName = trial.name;
        trialNCT = trial.title;
        break;
      }
    }
  }
  return (
    <div>
      <div className="flex items-center justify-center gap-2">
        <div className="relative">
          <img src={VivoLogo} alt="Vivo Logo" />
        </div>
        <div
          data-testid="ask-vivo-page-title"
          className="text-[41px] text-[#64BDE1] font-semibold"
        >
          Ask Vivo
        </div>
      </div>

      {scope === "portfolio" ? (
        <p className="flex items-center mt-3 mx-auto text-base text-[#333]">
          Ask Vivo anything about your clinical trial portfolio
        </p>
      ) : userInfo && userInfo.trials && userInfo.trials.length > 0 ? (
        <p
          data-testid="ask-vivo-trial-identity"
          className="flex items-center mt-3 mx-auto text-base text-[#333]"
        >
          Ask Vivo anything about the{" "}
          <span className="ml-2 mr-2 text-[16px] font-semibold">
            {trialName} | {trialNCT}
          </span>{" "}
          study
        </p>
      ) : (
        <p className="flex items-center mt-3 mx-auto text-base text-[#333]">
          Ask Vivo anything about your study
        </p>
      )}
    </div>
  );
}
